import axios from 'axios';
import { API_URL } from './config';

class LoginDeailsService {

    constructor() {
        this. CallLoginAPI = () => (axios.post(`${API_URL}user/CallLoginAPI`));
    }
}
export default new LoginDeailsService();



